import axios from 'axios'
import { ENV_CONFIG } from '../constants'

export const API = axios.create({
	baseURL: ENV_CONFIG.api_url,
	headers: {
		'X-API-KEY': ENV_CONFIG.api_key
	}
})
